import { useEffect, useMemo, useState } from "react";
import NewsCard from "@/components/base/NewsCard";
import { getPublicNews } from "@/lib/webContentApi";
import { NewsItem } from "@/lib/webContentTypes";

export default function NewsPage() {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [items, setItems] = useState<NewsItem[]>([]);

  useEffect(() => {
    getPublicNews()
      .then((value) => setItems(value.filter((item) => item.active)))
      .catch(() => setItems([]));
  }, []);

  const categories = useMemo(() => {
    const values = Array.from(new Set(items.map((item) => item.category).filter(Boolean)));
    return ["Todos", ...values];
  }, [items]);

  const filtered = items.filter(
    (n) => activeCategory === "Todos" || n.category === activeCategory,
  );

  return (
    <main className="pt-24 pb-20 min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-sky-500 text-sm font-semibold uppercase tracking-wider">APR Quechurehue</span>
          <h1
            className="text-4xl md:text-5xl font-extrabold text-sky-900 mt-2 mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Noticias y Comunicados
          </h1>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Toda la informacion actualizada sobre el APR, actividades, cortes programados y mas.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-sky-500 text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-sky-50 hover:text-sky-600"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-20 text-slate-400">
            <i className="ri-newspaper-line text-5xl mb-4 block"></i>
            <p>No hay noticias en esta categoria.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((news) => (
              <NewsCard key={news.id} news={news} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}

